import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, showMessageToastCustom, isNullOrEmpty, getPathApp, configs } from '../../../utils/util';
import { BackButton, Button, Input, ScannerCode } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import SupplierModal from './../Receipt/SupplierModal';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import { endLoading } from '../../../actions/loadingAction';

const MultiInvoice = (props) => {
    const [invoices, setinvoices] = useState([]);
    const [invoice, setinvoice] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [suppliers, setSuppliers] = useState([]);

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            addinvoice(invoice);
        }
    }

    const addinvoice = (invoiceAdd) => {
        if (!invoices.find((item) => item === invoiceAdd)) {
            if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
                const filter = { invoice: invoiceAdd }
                props.verifyDuplication(filter, (res) => {
                    props.hideLoading();
                    if (res.data.length > 1) {
                        setModalVisible(true)
                        setSuppliers(res.data, res.data[0])
                    } else {
                        newInvoice(invoiceAdd, res.data[0])
                    }
                })
            } else {
                newInvoice(invoiceAdd)
            }
        } else {
            showMessageToastCustom(translate('general:warning'), translate('general:already-exists'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const newInvoice = (invoiceAdd, supplier) => {
        invoices.push({ Invoice: invoiceAdd, Supplier: supplier });
        setinvoices([...invoices]);
        setinvoice('');
    }

    const onConfirmModal = (supplier) => {
        newInvoice(invoice, supplier)
        setModalVisible(false)
    }

    const removedinvoice = (item) => {
        const items = invoices.filter((data) => data !== item);
        if (items) {
            setinvoices([...items]);
        } else {
            setinvoices([]);
        }
    }

    const onQrCodeReadHandler = (data) => {
        if (!isNullOrEmpty(data)) {
            addinvoice(data);
        }
    }

    const loadShedRequired = () => {
        const configItem = configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items);
        return Boolean(configItem?.shedRequiredPhysicalConfirmation)
    }


    const loadDockRequired = () => {
        const configItem = configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items);
        return Boolean(configItem?.dockRequiredPhysicalConfirmation)
    }



    const onSearch = () => {
        var dockRequired = loadDockRequired();
        var shedRequired = loadShedRequired();
        const shed = !shedRequired ? "" : props.sheds.find((i) => i.id === props.user.shed).code;
        var filter = {
            invoicesSuppliers: invoices,
            shed,
            dock: !dockRequired ? "M01" : props.user.dock
        }
        props.setFilter(filter);
        props.search(filter, () => {
            props.history.replace({
                state: {
                    multiInvoice: true
                },
                pathname: `${getPathApp(window)}/receipt/V2/receiptStorages`
            });
        });
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '0px', paddingTop: '5px', marginTop: '20px' }}>
                        <div className="row">
                            <div className="col s9">
                                <div className="input-field padding col s12">
                                    <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={onQrCodeReadHandler} />
                                    <Input
                                        onKeyDown={(e) => handleOnKeyDown(e)}
                                        required
                                        id="invoice"
                                        name="invoice"
                                        placeholder={translate("invoice", 'physical-confirmation')}
                                        type="text"
                                        onChange={(event) => { setinvoice(event.target.value) }}
                                        value={invoice || ''}
                                    />
                                </div>
                            </div>
                            <div className="col s3 center">
                                <button
                                    className="btn-floating btn-large btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => addinvoice(invoice)}
                                >
                                    <i className="material-icons">add_circle</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {invoices.length > 0 && invoices.map((item, index) => (
                    <ul key={`ul${index}-${item}`} className="collection col s12" style={{ margin: 0 }}>
                        <div key={`${index}-${item}`}>
                            <>
                                <span
                                    className="title sixth-text-color right"
                                    style={{ position: 'absolute', marginTop: '7px', right: '6px', zIndex: '999' }}
                                >
                                    <i onClick={() => removedinvoice(item)}
                                        className={`mdi mdi-36px mdi-trash-can-outline green-text`} />
                                </span>
                            </>
                            <li
                                key={item}
                                className="collection-item z-depth-1"
                                style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
                            >
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <span style={{ padding: '0px', paddingLeft: '0px' }}>
                                        {translate("invoice", 'physical-confirmation')} : {item.Invoice}
                                        {item.Supplier && ` - ${item.Supplier}`}
                                    </span>
                                </div>
                            </li>
                        </div>
                    </ul>
                ))
                }
                {
                    invoices.length > 0 &&
                    <div className="row">
                        <Button onClick={onSearch} full="true" text={translate('general.confirm')} />
                    </div>
                }
            </div>
            <SupplierModal
                open={modalVisible}
                id="confirmDeleteReceipt"
                data={suppliers.map((i) => { return { id: i, text: i }; })}
                onConfirm={(e) => onConfirmModal(e)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        sheds: state.configReducer.sheds,
        user: state.userReducer.user,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        search: (filter, callback) => {
            dispatch(PhysicalConfirmationService.searchList(filter, callback));
        },
        setFilter: (filter) => {
            dispatch(PhysicalConfirmationService.setFilter(filter));
        },
        verifyDuplication: (filter, callback) => {
            dispatch(PhysicalConfirmationService.verifyDuplication(filter, callback));
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MultiInvoice));
